import {ConnectionUserInfoObj} from './ConnectionUserInfoObj';

export class FtpConfigurationObj {
defaultPath: string;
privateKey: string;
protocole: string;
userInfo: ConnectionUserInfoObj;
}

